import posthog from "posthog-js";

posthog.init(process.env.POSTHOG_KEY, {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
});

export default posthog;
